import React from 'react'
import { bool, func } from 'prop-types'
import styled from 'styled-components'

import { H4 } from 'styles/typography'
import Modal, { ModalSection } from 'components/Modal'
import Button from 'components/button/Button'
import ButtonGroup from 'components/button/ButtonGroup'
import { NativeAuthConsumer } from 'components/NativeAuth'

const Inner = styled.div`
  text-align: center;
`

const PauseSubscriptionModal = ({ visible, close }) => {
  return (
    <Modal visible={visible} close={close}>
      <ModalSection>
        <Inner>
          <H4>Pause subscription</H4>
          <p>
            Are you sure you want to pause your recurring subscription? You will no longer receive your items until you
            have unpaused it.
          </p>
          <NativeAuthConsumer>
            {({ setPauseSubscriptionModalVisibility, editSubscription, token }) => {
              return (
                <ButtonGroup>
                  <Button
                    onClick={() => {
                      editSubscription({ isPaused: true, token })
                      setPauseSubscriptionModalVisibility(false)
                    }}
                    theme="primary"
                  >
                    Yes, pause subscription
                  </Button>
                  <Button
                    onClick={() => {
                      setPauseSubscriptionModalVisibility(false)
                    }}
                    theme="secondary"
                  >
                    No, return
                  </Button>
                </ButtonGroup>
              )
            }}
          </NativeAuthConsumer>
        </Inner>
      </ModalSection>
    </Modal>
  )
}

PauseSubscriptionModal.propTypes = {
  visible: bool.isRequired,
  close: func.isRequired
}

export default PauseSubscriptionModal
